"use client";
import React from "react";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { I18nUtil } from "@utils";
import Translations from "@translate/components/TradeCardInfo/TradeCardInfo";

const I18n = I18nUtil.createScoped(Translations);

interface TradeCardInfoProps {
  className?: string;
  onClick?: () => void;
}

export const TradeCardInfo: React.FC<TradeCardInfoProps> = ({
  className = "",
  onClick,
}) => {
  return (
    <div
      data-openreplay-label="TradeCardInfo · TradeCardInfo · div"
      className={`flex items-center gap-3 p-3 pr-6 bg-background_solid_tertiary rounded-xl relative ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center flex-none py-1">
        <div className="flex items-center justify-center rounded-2 bg-background_brand_overlay10 p-[10px]">
          <OspIcons
            name="ic_withdraw"
            className="text-content_brand_primary"
            size={16}
          />
        </div>
      </div>
      <div className="flex flex-col items-start flex-1">
        <p className="font-body-l-medium text-content_primary -mt-[1px] w-fit whitespace-nowrap">
          {I18n.t("Turn This Analysis Into A Trade Now")}
        </p>

        <p className="body_s w-full text-content_tertiary">
          {I18n.t(
            "Analysis is great, but without action, it's just cope. Take control of your portfolio now and execute trades directly via our integrated exchanges.",
          )}
          <br />
          {I18n.t("Recommended exchanges: Binance.")}
        </p>
      </div>
      <div className="inline-flex items-center justify-center gap-2.5 bg-background_brand_overlay20 rounded-[0_12px_0_12px] p-1 px-2 absolute right-0 top-0">
        <div className="body_medium_s text-content_brand_primary w-fit whitespace-nowrap">
          {I18n.t("Coming soon")}
        </div>
      </div>
    </div>
  );
};
